import { default as _ } from "underscore";

export class In {
    type;

    canActivate(params) {
        if (params.type === "canactivatefalse") {
            return false;
        }
        if (params.type === "canactivatethrow") {
            this.throwError();
        }

        if (params.type === "canactivatepromisethrow") {
            return new Promise((success, fail) => {
                        this.throwError();
            });
        }
    }

    activate(params) {
        this.type = params.type;

        if (this.type === "activatethrow") {
            this.throwError();
        }

        if (this.type === "activatepromisethrow") {
            return new Promise((success, fail) => {
                this.throwError();
            });
        }
    }

    attached() {
        if (this.type === "attachedthrow") {
            this.throwError();
        }

        if (this.type === "attachedpromisethrow") {
            return new Promise((success, fail) => {
                this.throwError();
            });
        }
    }

    throwError() {
        throw new Error("Test");
    }
}